import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../../Services/axiosCommon";
import moment from "moment";
import NuDate from "../../Components/Utils/NuDate";
import logout from "../../Components/Utils/Logout";
import ModalContainer from "../../Components/Others/ModalContainer";
import BellIcon from "../../Components/Icons/BellIcon";
import DecryptData from "../../Components/Utils/Decrypt";
import LanguageSelector from "../../Components/Others/LanguageSelector";
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import Dashboard from "../../Components/Icons/Dasboard";
import { useCurrency } from "../../Context/CurrencyContext";
import socketAxiosInstance from "../../Services/socketAxiosCommon";
import {
  GetAccess,
  GetDashboardRole,
  GetMultipleAccess,
  GetRole,
} from "../../Components/Utils/roles";
import { useToast } from "../../Components/Others/ToastServices";
import Chat from "../../Components/Icons/Chat";
import { useSocket } from "../../Context/SocketContext";
import { MenuOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import Members from "../../Components/Icons/Member";
import DashboardSide from "../../Components/Icons/DasboardSide";
import Bidding from "../../Components/Icons/Bidding";
import Project from "../../Components/Icons/Project";
import Notes from "../../Components/Icons/Notes";
import Procurement from "../../Components/Icons/Procurement";
import Sales from "../../Components/Icons/Sales";
// import Store from "../../Components/Icons/Store";
import Contacts from "../../Components/Icons/Contacts";
import Report from "../../Components/Icons/Report";
import Settings from "../../Components/Icons/Settings";
import Costing from "../../Components/Icons/Budget";
import PlanTask from "../../Components/Icons/Planning";
import Task from "../../Components/Icons/Task";
import Progress from "../../Components/Icons/progress";
import Timesheet from "../../Components/Icons/TimeSheet";
import CompanyInfoIcon from "../../Components/Icons/Company";
import Products from "../../Components/Icons/Products";
import Shipping from "../../Components/Icons/Shipping";
import Role from "../../Components/Icons/Role";
import Staff from "../../Components/Icons/Staff";
import UserRole from "../../Components/Icons/UserRole";
import Reference from "../../Components/Icons/Reference";
import CurrencyIcon from "../../Components/Icons/Currency";
import PermissionIcon from "../../Components/Icons/Status";
import Email from "../../Components/Icons/Email";
import Template from "../../Components/Icons/Template";
import PDFTemplateIcon from "../../Components/Icons/PdfTemplate";
import Signature from "../../Components/Icons/Signatutre";
 import {
  Building2,
  Gavel,
  PackageSearch,
  Truck,
  FolderKanban,
  ShoppingCart,
  Users,
  BookUser,
  Store,
  Send,
  ShieldCheck,
  UserCog,
  UserCircle,
  Bell,
  Mail,
  Link2,
  DollarSign,
  PenTool,
  Shield,
  ClipboardCheck,
  Server,
  FilePlus,
  FileText as FileTextIcon,
  StickyNote,
  LayoutDashboard,
  NotebookPen,
  CalendarCheck,
  BarChart2,
  ListChecks,
  TrendingUp,
  FileText,
  Warehouse,
  ArrowLeft,
  LogOut,
} from "lucide-react";
function Navbar() {
  const toast = useToast();
  const userDetails = DecryptData("sLiAtEdReSuEdArT") || "";
  const hasMutipleOffice = localStorage.getItem("hasmutiple")
    ? JSON.parse(localStorage.getItem("hasmutiple"))
    : false;
  const branchId = localStorage.getItem("branchId")
    ? JSON.parse(localStorage.getItem("branchId"))
    : 1;
  const { officeId } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notifCount, setNotifCount] = useState(0);
  const [msgCount, setMsgCount] = useState(0);
  const [message, setMessage] = useState([]);
  const { updateCurrency } = useCurrency();

  const [open, setOpen] = useState(false);
  const [noti, setNoti] = useState([]);
  const [title, setTitle] = useState({
    Name: "",
    Country: "",
  });

  function getCompanyName() {
    axiosInstance
      .get(`/company-info/1`)
      .then((res) => {
        res.data?.data &&
          setTitle({
            Name: res.data?.data?.companyName,
            Country: res.data.data?.compLogo?.file || "",
          });
        updateCurrency(res.data.data?.currency);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getNotifications(userId) {
    socketAxiosInstance
      .get(`/notification/${userId}`)
      .then((res) => {
        if (res?.data?.status === true) {
          let data = res?.data?.data;

          data && setNoti(data?.notifications || []);
          data && setNotifCount(data?.count || 0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getComments(userId) {
    socketAxiosInstance
      .get(`/notification/comments/${userId}`)
      .then((res) => {
        if (res?.data?.status === true) {
          let data = res?.data?.data;

          data && setMessage(data?.notifications || []);
          data && setMsgCount(data?.count || 0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getCompanyName();
    getNotifications(userDetails?.id);
    getComments(userDetails?.id);
  }, []);

  const { connectionOn, handleNotifications, handleActiveUser } = useSocket();

  useEffect(() => {
    if (connectionOn == true) {
      handleNotifications((notification) => {
        if (notification.type == 1) {
          setNotifCount((prev) => prev + 1);
          setNoti((prev) => [notification, ...prev]);
        } else if (notification.type == 2) {
          setMsgCount((prev) => prev + 1);
          setMessage((prev) => [notification, ...prev]);
        }
        toast.open(
          {
            message: "New Notification",
            description: notification?.msg || "",
            name: notification?.name || "",
            date: notification?.date || "",
            time: notification?.time || "",
            type: "notification",
          },
          5000,
          true
        );
      });
    }
  }, [handleNotifications, connectionOn]);

  const [userList, setUserList] = useState([]);

  useEffect(() => {
    if (connectionOn == true && GetRole()) {
      handleActiveUser((userList) => {
        setUserList(userList);
      });
    }
  }, [handleActiveUser, connectionOn]);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const { pathname } = useLocation();
  const { projectId, projectID, projecTId, projeCtId, proJectId, projEctId } =
    useParams();

  console.log("PATH", pathname.includes("/settings/"));

  const Space = ({ children }) => {
    return <div className="flex">{children}</div>;
  };

  const Badge = ({ count, children }) => {
    return (
      <div className="relative inline-block">
        {children}
        {count > 0 && (
          <span className="absolute top-0 p-1 right-0 bg-red-500 text-white w-4 h-4 flex items-center justify-center rounded-full text-[8px]">
            {count}
          </span>
        )}
      </div>
    );
  };

  const Dropdown = ({ overlay, children, trigger }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false);
        }
      };

      if (isOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen]);

    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };

    const handleTrigger = () => {
      if (trigger === "click") {
        toggleDropdown();
      }
      // You can add support for other trigger events here if needed
    };

    return (
      <div
        className="relative inline-block"
        onClick={handleTrigger}
        ref={dropdownRef}
      >
        <div>{children}</div>
        {isOpen && (
          <div className="absolute right-[100%] top-[70%] w-48 bg-white rounded-md shadow-lg z-[99]">
            {overlay}
          </div>
        )}
      </div>
    );
  };

  const getUnreadCount = () => {
    return noti.filter((noti) => !noti.is_read).length;
  };

  function Menu() {
    const navigate = useNavigate();

    const handleNavigate = (module, id) => {
      switch (module) {
        case "pr":
          navigate(
            `/main/${branchId}/procurement/purchase-requests/view/${id}`
          );
          break;
        case "rfq":
          navigate(`/main/${branchId}/procurement/rfq/view/${id}`);
          break;
        case "supplier_quotes":
          navigate(`/main/${branchId}/procurement/rfq/view/${id}`, {
            state: { active: 2 },
          });
          break;
        case "purchase_order":
          navigate(`/main/${branchId}/procurement/purchase-order/view/${id}`);
          break;
        case "sales_order":
          navigate(`/main/${branchId}/sales/sales-orders/view/${id}`);
          break;
        case "customer_quotes":
          navigate(`/main/${branchId}/sales/quotes/view/${id}`);
          break;
        case "supplier":
          navigate(`/main/${branchId}/procurement/suppliers/view/${id}`);
          break;
        default:
          console.error("Invalid module");
      }
    };
    const handleRead = async (id) => {
      axiosInstance
        .put(`/notification/update/is_read/${id}`, {
          is_read: 1,
        })
        .then((res) => {
          setNoti((prev) =>
            prev.map((noti) =>
              noti?.notificationId === id ? { ...noti, is_read: true } : noti
            )
          );
          setNotifCount(getUnreadCount());
        })
        .catch((err) => {});
    };

    function ClearAll() {
      axiosInstance
        .delete(`/notification/delete`)
        .then((res) => {
          setNoti([]);
          setNotifCount(0);
        })
        .catch((err) => {});
    }

    function MarkAll() {
      axiosInstance
        .get(`/notification/update/mark_all_as_read`)
        .then((res) => {
          setNoti((prev) =>
            prev.map((noti) => {
              return { ...noti, is_read: true };
            })
          );
          setNotifCount(0);
        })
        .catch((err) => {});
    }

    return (
      <div className="w-72 h-96 bg-white shadow-lg rounded-md overflow-hidden">
      <div className="w-full h-10 bg-slate-200 flex justify-between items-center">
        <p className="font-bold ml-2">Notification</p>
        <div className="flex items-center gap-2">
          {notifCount > 0 && (
            <button
              className="outline-none border-none text-xs font-normal px-2 py-1 rounded bg-[#048178] text-white cursor-pointer"
              onClick={MarkAll}
            >
              Mark as Read
            </button>
          )}
          {noti.length > 0 && (
            <button
              className="outline-none border-none text-xs font-normal px-2 py-1 rounded bg-[#048178] text-white cursor-pointer"
              onClick={ClearAll}
            >
              Clear All
            </button>
          )}
        </div>
      </div>
      <div className="w-full h-[90%] overflow-y-scroll">
        {noti.map((notification, idx) => (
          <div
            key={idx}
            className={`w-full my-1 p-1  gap-1 flex justify-between items-center cursor-pointer border-b`}
            onClick={() => {
              handleRead(notification.notificationId);
              handleNavigate(notification.module, notification.id);
            }}
          >
            <div className="px-2 w-[15%] ">
              <div className="w-8 h-8 bg-baseColor-primary flex justify-center items-center text-white font-medium text-lg rounded-full overflow-hidden">
                {notification.sender_imageUrl ? (
                  // <img
                  //   src={notification.sender_imageUrl}
                  //   width="50px"
                  //   alt="Sender"
                  // />
                  <img
                                            src={
                                              notification.sender_imageUrl
                                                ? notification.sender_imageUrl
                                                : null
                                            }
                                            width="50px"
                                            alt={`${notification.sender_imageUrl}`}
                                          />
                ) : (
                  `${notification.name.charAt(0)}`
                )}
              </div>
            </div>
            <div
              className={`w-[85%] ${
                notification.is_read ? "font-normal" : "font-semibold"
              }`}
            >
                <p className="pb-1 text-ellipsis text-slate-900 leading-5 text-xs">
                       {notification?.msg}
                     </p>
                     <p className="text-[10px] text-slate-700">
                       By {notification?.name}{" "}
                       {moment(notification?.date).format("DD-MMM-YYYY")} at{" "}
                       <span className="text-[8px] text-slate-700">
                         <NuDate
                           value={`${notification?.date} ${notification?.time}`}
                           format="hh:mm a"
                         />
                       </span>
                     </p>
            </div>
          </div>
        ))}
      </div>
    </div>
    );
  }

  function Message() {
    const navigate = useNavigate();

    const handleNavigate = (module, id) => {
      navigate(`/main/${branchId}/procurement/purchase-requests/view/${id}`);
    };

    const handleRead = async (id) => {
      axiosInstance
        .put(`/notification/update/is_read/${id}`, {
          is_read: 1,
        })
        .then((res) => {
          setNoti((prev) =>
            prev.map((noti) =>
              noti?.notificationId === id ? { ...noti, is_read: true } : noti
            )
          );
          setNotifCount(getUnreadCount());
        })
        .catch((err) => {});
    };

    function ClearAll() {
      axiosInstance
        .delete(`/notification/delete/comments`)
        .then((res) => {
          setMessage([]);
          setMsgCount(0);
        })
        .catch((err) => {});
    }

    function MarkAll() {
      axiosInstance
        .get(`/notification/update/comments/mark_all_as_read`)
        .then((res) => {
          setNoti((prev) =>
            prev.map((noti) => {
              return { ...noti, is_read: true };
            })
          );
          setNotifCount(0);
        })
        .catch((err) => {});
    }

    return (
      <>
        <div className="w-72 h-96 z-[99]  bg-white shadow-lg rounded-md overflow-hidden">
          <div className=" w-full h-10 bg-slate-200 flex justify-between items-center">
            <p className="font-bold ml-2">Comments</p>
            <div className=" flex items-center gap-2">
              {msgCount > 0 ? (
                <button
                  className=" outline-none border-none text-xs font-normal px-2 py-1 rounded bg-mainColor-300 text-white cursor-pointer bg-[#048178]"
                  onClick={MarkAll}
                >
                  Marks as read
                </button>
              ) : null}
              {message.length > 0 ? (
                <button
                  className=" outline-none border-none text-xs font-normal px-2 py-1 rounded bg-mainColor-300 text-white cursor-pointer bg-[#048178]"
                  onClick={ClearAll}
                >
                  Clear All
                </button>
              ) : null}
            </div>
          </div>
          <div className="w-full h-[90%] overflow-y-scroll">
            {message?.map((notification, idx) => {
              return (
                <>
                  <div
                    className={
                      // notification?.is_read ? "bg-white" : " bg-slate-100"
                    `w-full my-1 p-1 border-b gap-1 flex justify-between items-center cursor-pointer`}
                    onClick={() => {
                      notification?.is_read != true && handleRead(notification?.notificationId);
                      handleNavigate(notification.module, notification.id);

                    }}
                  >
               
                    <div className="px-2 w-[15%]">
                      {/* <NuAvatarGroup userdetails={[{name:`${notification?.sender_fName}`,imageUrl:`${notification?.sender_imageUrl}`}]} />    */}
                      <div className="w-8 h-8 bg-baseColor-primary  flex justify-center items-center text-white font-medium text-lg rounded-full overflow-hidden">
                        {notification.sender_imageUrl ? (
                          <img
                            src={
                              notification.sender_imageUrl
                                ? notification.sender_imageUrl
                                : null
                            }
                            width="50px"
                            alt={`${notification.sender_imageUrl}`}
                          />
                        ) : (
                          `${notification?.name?.charAt(0)}`
                        )}
                      </div>
                    </div>
                    <div
                      className={`w-[85%] ${
                        notification?.is_read
                          ? " font-normal "
                          : "font-medium  "
                      }`}
                    >
                      {/* <p className='font-semibold'>Admin <span className='font-normal'>to</span> Login Person</p> */}
                      <p className="pb-1 text-ellipsis text-slate-900 leading-5 text-xs">
                        {notification?.msg}
                      </p>
                      <p className="text-[10px] text-slate-700">
                        By {notification?.name}{" "}
                        {moment(notification?.date).format("DD-MMM-YYYY")} at{" "}
                        <span className="text-[8px] text-slate-700">
                          <NuDate
                            value={`${notification?.date} ${notification?.time}`}
                            format="hh:mm a"
                          />
                        </span>
                      </p>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </>
    );
  }

  const handleLogOut = async () => {
    setIsModalOpen(true);
  };

  function OnlineUsers({ list = [] }) {
    return (
      <>
        <div className="w-72 h-96 relative  bg-white shadow-lg rounded-md overflow-y-auto overflow-x-hidden px-2">
          <p className=" w-full sticky top-0 py-1 bg-white font-semibold text-xs 2xl:text-sm text-gray-900">
            Online User
          </p>
          {list &&
            list.map((user, index) => (
              <div
                className=" w-full flex justify-start items-center gap-x-3 my-1"
                key={index}
              >
                <div className=" w-[45px] h-[45px] rounded-full text-white  flex justify-center overflow-hidden items-center bg-baseColor-primary border border-white">
                  {user.image != "" && user.image != null ? (
                    <>
                      <img
                        src={user.image}
                        alt="#"
                        height={"45px"}
                        width="auto"
                      />
                    </>
                  ) : (
                    <>{getInitials(user?.name || "")}</>
                  )}
                </div>
                <p className=" text-gray-900 font-medium text-xs 2xl:text-sm">
                  {user?.name}
                </p>
              </div>
            ))}
        </div>
      </>
    );
  }

  const getInitials = (name) => {
    const names = name.split(" ");
    if (names.length > 1) {
      return names[0][0] + names[1][0];
    }
    return names[0][0];
  };

  const NavItems = [
  {
    icon: <LayoutDashboard size={18} />,
    title: "Dashboard",
    hasSubMenu: false,
    hasAccess: true,
    link: GetDashboardRole("") ? "dashboard" :
      GetDashboardRole("sales") ? `/main/${officeId}/dashboard/sales` :
      GetDashboardRole("procurement") ? `/main/${officeId}/dashboard/procurement` :
      GetDashboardRole("store") ? `/main/${officeId}/dashboard/stores` :
      `/main/${officeId}/dashboard`,
  },

  {
    icon: <Gavel size={18} />,
    title: "Bidding",
    link: GetAccess("bids_view") ? `/main/${officeId}/bidding/bids` :
      GetAccess("estimation_view") ? `/main/${officeId}/bidding/estimation` :
      GetAccess("activity_item_view") ? `/main/${officeId}/bidding/activity` :
      GetAccess("terms_and_condition_view") ? `/main/${officeId}/bidding/teamandcondition` : "#",
    access: GetAccess("bidding_module"),
    hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <FolderKanban size={18} />,
    title: "Projects",
    link: GetAccess("project_view") ? `/main/${officeId}/projects` : "#",
    access: GetAccess("project_module"),
    hasSubMenu: false,
  },

  {
    icon: <NotebookPen size={18} />,
    title: "My Diary",
    link: GetAccess("my_diary_view") ? `/main/${officeId}/mainNotes` : "#",
    access: GetAccess("my_diary_module"),
    hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <CalendarCheck size={18} />,
    title: "HR",
    link: GetAccess("attendance_view") ? `/main/${officeId}/hr/attendance` :
      GetAccess("timesheets_view") ? `/main/${officeId}/hr/timesheets` :
      GetAccess("team_view") ? `/main/${officeId}/hr/team` : "#",
    hasAccess: ["attendance_view", "timesheets_view", "team_view"],
    hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <Truck size={18} />,
    title: "Procurement",
    link: GetAccess("create_product") ? `/main/${officeId}/procurement/items` :
      GetAccess("purchase_request_view") ? `/main/${officeId}/procurement/purchase-requests` :
      GetAccess("suppliers_view") ? `/main/${officeId}/procurement/product-comparison` :
      GetAccess("rfq_view") ? `/main/${officeId}/procurement/rfq` :
      GetAccess("purchase_order_view") ? `/main/${officeId}/procurement/purchase-order` :
      GetAccess("payment_request_view") ? `/main/${officeId}/procurement/payment-request` : "#",
    hasAccess: ["purchase_request_view", "rfq_view", "supplier_quote_view", "quote_compare_view", "purchase_order_view", "suppliers_view"],
    hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <ClipboardCheck size={18} />,
    title: "Invoices",
    link: GetAccess("invoice_in_view") ? `/main/${officeId}/sales/invoice_incoming` :
      GetAccess("invoice_out_view") ? `/main/${officeId}/sales/invoice_outgoing` : "#",
    hasAccess: ["customers_view", "customer_quote_view", "customer_order_view", "sales_order_view", "invoice_in_view", "invoice_out_view", "promotions_view"],
    hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <Store size={18} />,
    title: "Store",
    link: GetAccess("shipment_tracking_view") ? `/main/${officeId}/store/shipment-tracking` :
      GetAccess("grn_view") ? `/main/${officeId}/store/grn` :
      GetAccess("inventory_view") ? `/main/${officeId}/store/inventory` :
      GetAccess("assets_view") ? `/main/${officeId}/store/assets` :
      GetAccess("delivery_notes_view") ? `/main/${officeId}/store/delivery-note` :
      GetAccess("returns_view") ? `/main/${officeId}/store/returns` :
      GetAccess("requests_view") ? `/main/${officeId}/store/requests` : "#",
    hasAccess: ["shipment_tracking_view", "grn_view", "inventory_view", "assets_view", "delivery_notes_view", "packing_list_view", "returns_view", "requests_view"],
    hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <Users size={18} />,
    title: "Employees",
    link: GetAccess("employees_view") ? `/main/${officeId}/employees` : "#",
    access: GetAccess("contacts_module"),
    hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <BookUser size={18} />,
    title: "Contacts",
    link: GetAccess("customers_view") ? `/main/${officeId}/contacts/customers` :
      GetAccess("sub_contractor_view") ? `/main/${officeId}/contacts/sub-con` :
      GetAccess("vendor_view") ? `/main/${officeId}/contacts/suppliers` :
      GetAccess("rental_manpower_view") ? `/main/${officeId}/contacts/rental-man` :
      GetAccess("agents_view") ? `/main/${officeId}/contacts/agents` : "#",
    hasAccess: ["contacts_module", "rental_manpower_view", "vendor_view", "customers_view", "sub_contractor_view", "agents_view"],
    hasSubMenu: false,
    subMenu: [],
  },

  {
    icon: <BarChart2 size={18} />,
    title: "Report",
    link: `/main/${officeId}/reports`,
    hasAccess: ["report_view"],
    hasSubMenu: false,
  },
];

const effectiveProjectId = projectId || projectID || projecTId || projeCtId || proJectId || projEctId;

const ProjectNavItem = [
  {
    icon: <LayoutDashboard size={16} />,
    title: "Dashboard",
    hasSubMenu: false,
    hasAccess: true,
    link: `/project/dashboard/${officeId}/${effectiveProjectId}`,
  },
  {
    icon: <DollarSign size={16} />,
    title: "Budget",
    hasSubMenu: false,
    hasAccess: ["man_power_view", "material", "others"],
    link: `/project/costing/man-power/${officeId}/${effectiveProjectId}`,
  },
  {
    icon: <CalendarCheck size={16} />,
    title: "Planning",
    hasSubMenu: false,
    hasAccess: ["activities", "time_line"],
    link: `/project/main-taskplan/main-task-plan/${officeId}/${effectiveProjectId}`,
  },
  {
    icon: <ListChecks size={16} />,
    title: "Task",
    hasSubMenu: false,
    hasAccess: ["my_task_view", "all_task_view"],
    link: `/project/tasks/my-task/${officeId}/${effectiveProjectId}`,
  },
  {
    icon: <TrendingUp size={16} />,
    title: "Progress",
    hasSubMenu: false,
    hasAccess: ["man_power", "material", "Equipment", "others"],
    link: `/project/progress/man-power/${officeId}/${effectiveProjectId}`,
  },
  {
    icon: <Users size={16} />,
    title: "HR",
    hasSubMenu: false,
    hasAccess: ["attendance", "timesheets", "team"],
    link: `/project/hr/attendance/${officeId}/${effectiveProjectId}`,
  },
  {
    icon: <ShoppingCart size={16} />,
    title: "Procurement",
    hasSubMenu: false,
    hasAccess: [
      "purchase_request_view",
      "rfq_view",
      "supplier_quote_view",
      "quote_compare_view",
      "purchase_order_view",
      "suppliers_view",
    ],
    link: `/project/procurement/ypr/${officeId}/${effectiveProjectId}`,
    subMenu: []
    //   {
    //     name: "YPR",
    //     link: `/project/procurement/ypr/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "purchase_request_view",
    //   },
    //   {
    //     name: "RFQ",
    //     link: `/project/procurement/rfq/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "rfq_view",
    //   },
    //   {
    //     name: "Quote Comparison",
    //     link: `/project/procurement/quote-comparison/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "quote_compare_view",
    //   },
    //   {
    //     name: "Purchase Order",
    //     link: `/project/procurement/purchase-order/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "purchase_order_view",
    //   },
    //   {
    //     name: "Supplier",
    //     link: `/project/procurement/suppliers/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "suppliers_view",
    //   },
    //   {
    //     name: "Payment Request",
    //     link: `/project/procurement/payment-request/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "payment_request_view",
    //   },
    //   {
    //     name: "Product Comparison",
    //     link: `/project/procurement/product-comparison/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "suppliers_view",
    //   },
    //   {
    //     name: "Team Performance",
    //     link: `/project/procurement/team-performance/${officeId}/${effectiveProjectId}`,
    //     hasAccess: GetDashboardRole("management"),
    //   },
    // ],
  },
  {
    icon: <FileText size={16} />,
    title: "Invoices",
    hasSubMenu: false,
    hasAccess: [
      "customers_view",
      "customer_quote_view",
      "customer_order_view",
      "sales_order_view",
      "invoice_in_view",
      "invoice_out_view",
      "promotions_view",
    ],
    link: `/project/sales/invoice_incoming/${officeId}/${effectiveProjectId}`,
    subMenu: []
    // [
    //   {
    //     name: "Customer",
    //     link: `/project/sales/customers/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "customers_view",
    //   },
    //   {
    //     name: "Quote",
    //     link: `/project/sales/quotes/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "customer_quote_view",
    //   },
    //   {
    //     name: "Customer Order",
    //     link: `/project/sales/customer-order/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "customer_order_view",
    //   },
    //   {
    //     name: "Sales Order",
    //     link: `/project/sales/sales-orders/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "sales_order_view",
    //   },
    //   {
    //     name: "Invoices Incoming",
    //     link: `/project/sales/invoice_incoming/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "invoice_in_view",
    //   },
    //   {
    //     name: "Invoices Outgoing",
    //     link: `/project/sales/invoice_outgoing/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "invoice_out_view",
    //   },
    // ],
  },
  {
    icon: <Warehouse size={16} />,
    title: "Store",
    hasSubMenu: false,
    hasAccess: [
      "grn_view",
      "inventory_view",
      "assets_view",
      "delivery_notes_view",
      "packing_list_view",
      "returns_view",
      "requests_view",
      "shipment_status_view",
    ],
    link: `/project/store/shipment-status/${officeId}/${effectiveProjectId}`,
    subMenu: []
    // [
    //   {
    //     name: "GRN",
    //     link: `/project/store/grn/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "grn_view",
    //     icon: <ClipboardCheck size={16} />,
    //   },
    //   {
    //     name: "Inventory",
    //     link: `/project/store/inventory/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "inventory_view",
    //     icon: <PackageCheck size={16} />,
    //   },
    //   {
    //     name: "Asset",
    //     link: `/project/store/assets/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "assets_view",
    //     icon: <Package size={16} />,
    //   },
    //   {
    //     name: "Delivery Note",
    //     link: `/project/store/delivery-note/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "delivery_notes_view",
    //     icon: <Truck size={16} />,
    //   },
    //   {
    //     name: "Packing List",
    //     link: `/project/store/packing-list/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "packing_list_view",
    //     icon: <Box size={16} />,
    //   },
    //   {
    //     name: "Return",
    //     link: `/project/store/returns/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "returns_view",
    //     icon: <RefreshCw size={16} />,
    //   },
    //   {
    //     name: "Request",
    //     link: `/project/store/requests/${officeId}/${effectiveProjectId}`,
    //     hasAccess: "requests_view",
    //     icon: <FileSearch size={16} />,
    //   },
    // ],
  },
];

const SettingsNavItem = [
  {
    icon: <Building2 size={16} />,
    title: "Company Info",
    link: `/settings/${officeId}`,
    hasAccess: "company_info_view",
  },
  {
    icon: <Gavel size={16} />,
    title: "Bidding",
    link: `/settings/${officeId}/bidding`,
    hasAccess: "bids_view",
  },
   {
    icon: <FolderKanban size={16} />,
    title: "Project",
    link: `/settings/${officeId}/project`,
    hasAccess: "project_view",
  },
  {
    icon: <ShoppingCart size={16} />,
    title: "Products",
    link: `/settings/${officeId}/products`,
    hasAccess: "product_view",
  },
  {
    icon: <Truck size={16} />,
    title: "Procurement",
    link: `/settings/${officeId}/procurement`,
    hasAccess: "procurement_view",
  },
 
  {
    icon: <PackageSearch size={16} />,
    title: "Sales",
    link: `/settings/${officeId}/sales`,
    hasAccess: "sales_view",
  },
  {
    icon: <Users size={16} />,
    title: "Employee",
    link: `/settings/${officeId}/employee`,
    hasAccess: "employees_view",
  },
  {
    icon: <BookUser size={16} />,
    title: "Contract",
    link: `/settings/${officeId}/contract`,
    hasAccess: "contract_view",
  },
  {
    icon: <Store size={16} />,
    title: "Store",
    link: `/settings/${officeId}/store`,
    hasAccess: "store_view",
  },
  {
    icon: <Send size={16} />,
    title: "Shipping",
    link: `/settings/${officeId}/shipping`,
    hasAccess: "shipping_view",
  },
  {
    icon: <ShieldCheck size={16} />,
    title: "Role",
    link: `/settings/${officeId}/role`,
    hasAccess: "role_view",
  },
  {
    icon: <UserCog size={16} />,
    title: "User",
    link: `/settings/${officeId}/user`,
    hasAccess: "user_view",
  },
  {
    icon: <UserCircle size={16} />,
    title: "User Role",
    link: `/settings/${officeId}/user-role`,
    hasAccess: "user_role_view",
  },
  {
    icon: <Bell size={16} />,
    title: "Notifications",
    link: `/settings/${officeId}/notifications`,
    hasAccess: "notification_view",
  },
  {
    icon: <Mail size={16} />,
    title: "Holidays",
    link: `/settings/${officeId}/user-holiday`,
    hasAccess: "user_holiday_view",
  },
  {
    icon: <Link2 size={16} />,
    title: "Reference",
    link: `/settings/${officeId}/reffrence`,
    hasAccess: "reference_view",
  },
  {
    icon: <DollarSign size={16} />,
    title: "Currency And Vat",
    link: `/settings/${officeId}/currency-vat`,
    hasAccess: "reference_view",
  },
  {
    icon: <PenTool size={16} />,
    title: "Seal And Signature",
    link: `/settings/${officeId}/sealandsignature`,
    hasAccess: "reference_view",
  },
  {
    icon: <Shield size={16} />,
    title: "Approval Permission",
    link: `/settings/${officeId}/statuspermission`,
    hasAccess: "reference_view",
  },
  {
    icon: <ClipboardCheck size={16} />,
    title: "Approval Status",
    link: `/settings/${officeId}/newApproval`,
    hasAccess: "reference_view",
  },
  {
    icon: <Server size={16} />,
    title: "Email Server",
    link: `/settings/${officeId}/emailserverdetails`,
    hasAccess: "reference_view",
  },
  {
    icon: <FilePlus size={16} />,
    title: "Template",
    link: `/settings/${officeId}/template`,
    hasAccess: "reference_view",
  },
  {
    icon: <FileTextIcon size={16} />,
    title: "PDF Template",
    link: `/settings/${officeId}/pdfTemplate`,
    hasAccess: "reference_view",
  },
  {
    icon: <StickyNote size={16} />,
    title: "PDF Notes",
    link: `/settings/${officeId}/notes`,
    hasAccess: "reference_view",
  },
];

  return (
    <>
      <style jsx>{`
        .circle-container .circle {
          position: relative;
          display: inline-block;
        }

        .circle-container .circle .circle-tooltip {
          visibility: hidden;
          max-width: 250px;
          height: 16px;
          background-color: #fff;
          color: #555;
          text-align: center;
          border-radius: 5px;
          padding: 5px;
          position: absolute;
          z-index: 20;
          top: 100%; /* Position the tooltip above the circle */
          left: 50%;
          transform: translateX(-50%);
          opacity: 0;
          transition: opacity 0.3s;
          border: 1px solid #048178;
        }

        .circle-container .circle:hover .circle-tooltip {
          visibility: visible;
          opacity: 1;
        }
      `}</style>
      <nav className=" w-full flex justify-between z-50">
        <div className=" w-4 lg:w-6/12 h-full p-3">
          <div className=" hidden h-full items-center lg:flex">
            {
              <div className=" flex justify-center items-center gap-2">
                {title.Country && (
                  <div className="max-w-[150px] h-10 overflow-hidden flex justify-center items-center">
                    <img
                      src={title.Country}
                      style={{ height: "40px", width: "auto" }}
                      alt="#fff"
                    />
                  </div>
                )}
                <span className=" text-base capitalize font-medium">
                  {title.Name || " "}
                </span>
              </div>
            }
          </div>
          <div className=" lg:hidden cursor-pointer" onClick={showDrawer}>
            <MenuOutlined />
          </div>
        </div>
        {GetRole() && (
          <>
            <div className=" w-[65%] h-[60px] mr-2 flex justify-end items-center">
              <div
                className="circle-container"
                style={{ display: "flex", alignItems: "center" }}
              >
                {userList && userList.length > 0 ? (
                  userList.slice(0, 10).map((name, index) => (
                    <React.Fragment key={index}>
                      {index == 9 ? (
                        <>
                          <div
                            className="circle text-xs"
                            style={{
                              width: "25px",
                              height: "25px",
                              borderRadius: "50%",
                              backgroundColor: "#3369ff",
                              color: "white",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "normal",
                              marginLeft: index !== 0 ? "-10px" : "0", // Add overlap effect
                              position: "relative",
                              zIndex: 1 + index, // Stack circles on top of each other
                              transition: "all 0.3s ease",
                              cursor: "pointer",
                              border: "1px solid #fff",
                            }}
                          >
                            <div className="">
                              <Dropdown
                                overlay={<OnlineUsers list={userList} />}
                                trigger="click"
                              >
                                <div className=" w-full h-full text-xs whitespace-nowrap">
                                  10+
                                </div>
                              </Dropdown>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div
                          className="circle text-xs"
                          style={{
                            width: "25px",
                            height: "25px",
                            borderRadius: "50%",
                            backgroundColor: "#3369ff",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "normal",
                            marginLeft: index !== 0 ? "-10px" : "0", // Add overlap effect
                            position: "relative",
                            zIndex: 1 + index, // Stack circles on top of each other
                            transition: "all 0.3s ease",
                            cursor: "pointer",
                            border: "1px solid #fff",
                          }}
                        >
                          {name.image != "" && name.image != null ? (
                            <div className=" w-[25px] h-[25px] rounded-full flex justify-center items-center overflow-hidden">
                              <img
                                src={name.image}
                                alt="#"
                                className=" w-auto h-[35px] object-cover"
                              />
                            </div>
                          ) : (
                            <>{getInitials(name?.name || "")}</>
                          )}
                          <div className="circle-tooltip ">
                            <div className=" -mt-[5px] text-xs whitespace-nowrap">
                              {name?.name || "-"}
                            </div>
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <p> </p>
                )}
              </div>
            </div>
          </>
        )}
        <div className=" flex justify-center items-center">
          <div className="px-0.5 mr-2 bg-slate-100 h-7 rounded-lg flex justify-center items-center  cursor-pointer">
            <Link
              to={
                hasMutipleOffice == true
                  ? `/main-page/dashboard`
                  : GetDashboardRole("")
                  ? `/main/${branchId}/dashboard`
                  : GetDashboardRole("sales")
                  ? `/main/${branchId}/dashboard/sales`
                  : GetDashboardRole("procurement")
                  ? `/main/${branchId}/dashboard/procurement`
                  : GetDashboardRole("store")
                  ? `/main/${branchId}/dashboard/stores`
                  : `/main/${branchId}/dashboard`
              }
            >
              <Dashboard />
            </Link>
          </div>
          <div className="mr-2">
            <Space>
              <Badge count={msgCount}>
                <Dropdown overlay={<Message />} trigger="click">
                  <div className=" px-1  flex justify-center items-center  cursor-pointer bg-slate-100  h-7 rounded-lg">
                    <Chat color="#1C274C" />
                  </div>
                </Dropdown>
              </Badge>
            </Space>
          </div>
          <div className="mr-2">
            <Space>
              <Badge count={notifCount}>
                <Dropdown overlay={<Menu />} trigger="click">
                  <div className=" px-1  flex justify-center items-center  cursor-pointer bg-slate-100  h-7 rounded-lg">
                    <BellIcon />
                  </div>
                </Dropdown>
              </Badge>
            </Space>
          </div>

          <div class=" md:p-2 flex items-center">
            <div className="dropdown inline-block relative">
              <button className=" text-gray-700 outline-none border-none bg-transparent font-semibold md:px-4 flex items-center">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />{" "}
                </svg>
                <div className=" relative w-9 h-9 mx-2 rounded-full bg-white overflow-hidden">
                  <div className="absolute z-10 bg-transparent top-0 left-0 w-full h-9 border rounded-full border-solid border-gray-400"></div>
                  {/* <div className="absolute z-20 bottom-0 right-0 bg-transparent w-1/2 h-9 border-8 rounded-r-full border-solid border-white -[#F4F2F8]"></div> */}
                  <div className="absolute z-30 w-full [calc(36px-4px)] h-full text-gray-600 [calc(36px-4px)] flex justify-center  capitalize items-center bg-transparent">
                    {
                      userDetails.image?
                      <img src={userDetails.image} alt="#"/>
                      :<div>{userDetails?.name?.charAt(0)}</div>
                    }
                  </div>
                </div>
                <div className=" hidden md:flex flex-col leading-none">
                  <p className="text-xs 2xl:text-sm font-semibold text-gray-500">
                    {userDetails?.name || " "}
                    {/* {userDetails?.userLastName || " "} */}
                  </p>
                </div>
              </button>
              <ul className="dropdown-menu pt-2 leading-none z-50 absolute hidden shadow-sm">
                <li className="list-none">
                  <Link
                    to={`/profile`}
                    className="rounded-t text-xs 2xl:text-sm bg-baseColor-teritary font-medium hover:bg-baseColor-quartary py-2  px-4 block whitespace-no-wrap"
                    href="#"
                  >
                    Profile
                  </Link>
                </li>

                <li className="list-none cursor-pointer">
                  <div
                    className="rounded-b text-xs 2xl:text-sm bg-baseColor-teritary font-medium hover:bg-baseColor-quartary py-2  px-4 block whitespace-no-wrap"
                    href="#"
                    onClick={handleLogOut}
                  >
                    Log Out
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <ModalContainer
          visiable={isModalOpen}
          title="Want to Logout?"
          content="Are you sure to logout from this app!"
          handleClick={() => logout()}
          closeModal={() => setIsModalOpen(false)}
        />
      </nav>

      <Drawer title="" placement="left" onClose={onClose} open={open}>
  <div className="h-[calc(100vh-110px)] flex flex-col overflow-hidden">
    {/* Fixed height container with scroll */}
    <div className="flex-1 overflow-y-auto">
      {pathname.includes("/main/") && (
        <>
          {NavItems.map((item, index) => {
            const { icon, title, hasAccess, link } = item;
            return (
              <div key={index} className="mb-1">
                {(hasAccess == true || GetMultipleAccess(hasAccess || [])) && (
                  <NavLink
                    to={link}
                    className={({ isActive }) =>
                      isActive
                        ? `w-full h-8 rounded-[6px] px-2 overflow-hidden border bg-sky-300 block text-white`
                        : `w-full h-8 overflow-hidden px-2 border block rounded-[9px] hover:bg-sky-100`
                    }
                    onClick={onClose}
                  >
                    <div className="flex gap-2 items-center h-full">
                      <span className="w-[28px] h-[28px] border rounded-[9px] flex items-center justify-center">
                        {icon}
                      </span>
                      <div className="text-xs font-medium">{title}</div>
                    </div>
                  </NavLink>
                )}
              </div>
            );
          })}
        </>
      )}

      {pathname.includes("/project/") && (
        <>
          {ProjectNavItem.map((item, index) => {
            const { icon, title, hasAccess, link } = item;
            return (
              <div key={index} className="mb-1">
                {(hasAccess == true || GetMultipleAccess(hasAccess || [])) && (
                  <NavLink
                    to={link}
                    className={({ isActive }) =>
                      isActive
                        ? `w-full h-8 rounded-[6px] px-2 overflow-hidden border bg-sky-300 block text-white`
                        : `w-full h-8 overflow-hidden px-2 border block rounded-[9px] hover:bg-sky-100`
                    }
                    onClick={onClose}
                  >
                    <div className="flex gap-2 items-center h-full">
                      <span className="w-[28px] h-[28px] border rounded-[9px] flex items-center justify-center">
                        {icon}
                      </span>
                      <div className="text-xs font-medium">{title}</div>
                    </div>
                  </NavLink>
                )}
              </div>
            );
          })}
        </>
      )}

      {pathname.includes("/settings/") && (
        <>
          <div className="mb-1">
            <NavLink
              to={`/main/${branchId}/dashboard`}
              className="w-full h-8 rounded-[6px] px-2 overflow-hidden border block hover:bg-sky-100"
            >
              <div className="flex gap-2 items-center h-full">
                <span className="w-[28px] h-[28px] border rounded-[9px] flex items-center justify-center">
                  <ArrowLeft size={16} />
                </span>
                <div className="text-xs font-medium">Back to Menu</div>
              </div>
            </NavLink>
          </div>

          {SettingsNavItem.map((item, index) => {
            const { icon, title, hasAccess, link } = item;
            return (
              <div key={index} className="mb-1">
                {GetMultipleAccess(hasAccess || []) && (
                  <NavLink
                    to={link}
                    className={({ isActive }) =>
                      isActive
                        ? `w-full h-8 rounded-[6px] px-2 overflow-hidden border bg-sky-300 block text-white`
                        : `w-full h-8 overflow-hidden px-2 border block rounded-[9px] hover:bg-sky-100`
                    }
                    onClick={onClose}
                  >
                    <div className="flex gap-2 items-center h-full">
                      <span className="w-[28px] h-[28px] border rounded-[9px] flex items-center justify-center">
                        {icon}
                      </span>
                      <div className="text-xs font-medium">{title}</div>
                    </div>
                  </NavLink>
                )}
              </div>
            );
          })}
        </>
      )}

      <div className="mb-1">
        <Link
          to="#"
          className="w-full h-8 rounded-[6px] px-2 overflow-hidden border block hover:bg-sky-100"
          onClick={() => {
            handleLogOut();
            onClose();
          }}
        >
          <div className="flex gap-2 items-center h-full">
            <span className="w-[28px] h-[28px] border rounded-[9px] flex items-center justify-center">
              <LogOut size={16} />
            </span>
            <div className="text-xs font-medium">Logout</div>
          </div>
        </Link>
      </div>

      {GetMultipleAccess([
        "company_info_view",
        "bids_view",
        "project_view",
        "product_view",
        "procurement_view",
        "sales_view",
        "employees_view",
        "contract_view",
        "store_view",
        "shipping_view",
        "role_view",
        "user_view",
        "user_role_view",
        "user_holiday_view",
        "reference_view",
      ]) && (
        <div className="mb-1">
          <Link
            to={`/settings/${branchId}`}
            className="w-full h-8 rounded-[6px] px-2 overflow-hidden border block hover:bg-sky-100"
          >
            <div className="flex gap-2 items-center h-full">
              <span className="w-[28px] h-[28px] border rounded-[9px] flex items-center justify-center">
                <Settings size={16} />
              </span>
              <div className="text-xs font-medium">Settings</div>
            </div>
          </Link>
        </div>
      )}
    </div>
  </div>
</Drawer>
    </>
  );
}

export default Navbar;
